import { forwardRef } from 'react';

import {
  BaseSelect,
  BaseSelectArrowDown,
  BaseSelectArrowUp,
  BaseSelectIndicator,
  BaseSelectItem,
  BaseSelectItemText,
  BaseSelectViewport,
  type ISelectDataProps,
} from '@gbs-monorepo-packages/common';

import { Container, Label } from './styles';

interface IHTMLDivElementExtension extends HTMLDivElement {
  dataCy?: string;
  name?: string;
  placeholder?: string;
  label?: string;
}

export interface IT {
  key: number | string;
  value: string;
}

export const CustomSelectData = forwardRef<
  IHTMLDivElementExtension,
  ISelectDataProps<IT>
>(
  // eslint-disable-next-line no-restricted-syntax
  function SelectData(
    {
      data,
      dataCy = 'select-data',
      name = 'select-name',
      placeholder = '',
      label,
      ...props
    },
    ref
  ): JSX.Element {
    return (
      <Container data-cy="container-custom-select" ref={ref}>
        {label && <Label>{label}</Label>}
        <BaseSelect
          dataCy={dataCy}
          placeholder={placeholder}
          name={name}
          {...props}
        >
          <BaseSelectArrowUp data-cy="arrow-up" />

          <BaseSelectViewport data-cy="view-port">
            {data.map(({ key, value }) => (
              <BaseSelectItem key={key} value={`${key}`} data-cy={`${key}`}>
                <BaseSelectItemText>{value}</BaseSelectItemText>
                <BaseSelectIndicator data-cy="item-selected-indicator" />
              </BaseSelectItem>
            ))}
          </BaseSelectViewport>

          <BaseSelectArrowDown data-cy="arrow-down" />
        </BaseSelect>
      </Container>
    );
  }
);


